<template>
  <AttachmentPreviewContainer
    type="Sale"
    :title="attachment.data.orderNumber"
    :info="`${attachment.data.dateLabel} with ${attachment.data.priceLabel}`"
    icon="sale"
    @remove="$emit('remove')"
  />
</template>

<script setup lang="ts">
import AttachmentPreviewContainer from '../../preview/Container.vue'

interface Props {
  attachment: Record<string, any>
}

defineProps<Props>()

const emit = defineEmits<{
  (e: 'remove'): void
}>()
</script>

